import React from "react";
import "./assets/scss/theme.scss";
import "./development.css";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import fakeBackend from "./helpers/AuthType/fakeBackend";
import DevelopmentPage from "./DevelopmentPage";

fakeBackend();

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
      />

      <DevelopmentPage />
    </>
  );
}

export default App;